import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
    取得優先處理問題,
    取得後續補強問題,
} from "@/lib/aiCitationOperations";
import { AlertCircle } from "lucide-react";

interface RecommendationsProps {
    results: any;
    onAddTrackingKeyword: (
        keyword: string,
        category?: string | null,
        primaryIntent?: "informational" | "commercial" | "transactional"
    ) => Promise<void>;
    isAddingTracking?: boolean;
}

export default function Recommendations({ results }: RecommendationsProps) {
    const 優先處理問題 = 取得優先處理問題(results);
    const 後續補強問題 = 取得後續補強問題(results);

    return (
        <div className="space-y-6">
            {優先處理問題.length === 0 && 後續補強問題.length === 0 ? (
                <Card>
                    <CardHeader>
                        <CardTitle>目前沒有明顯的此頁問題</CardTitle>
                    </CardHeader>
                    <CardContent className="text-sm text-muted-foreground">
                        這一頁目前沒有需要優先處理或後續補強的頁面級問題。
                    </CardContent>
                </Card>
            ) : null}

            {優先處理問題.length > 0 ? (
                <div className="space-y-4">
                    <div className="text-base font-semibold text-red-600">優先處理</div>
                    <div className="grid gap-4 xl:grid-cols-2">
                        {優先處理問題.map((card) => (
                            <Card key={card.key} className="border-red-200">
                                <CardHeader className="pb-2">
                                    <CardTitle className="text-base text-red-600 flex items-center gap-2">
                                        <AlertCircle className="h-4 w-4" />
                                        {card.title}
                                    </CardTitle>
                                </CardHeader>
                                <CardContent className="space-y-4">
                                    <div>
                                        <div className="text-sm font-medium mb-2">目前問題</div>
                                        <p className="text-sm text-muted-foreground leading-6">{card.problem}</p>
                                    </div>
                                    <div>
                                        <div className="text-sm font-medium mb-2">建議怎麼修</div>
                                        <ul className="list-disc pl-5 text-sm space-y-2">
                                            {card.howToFix.map((item) => (
                                                <li key={item}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                </div>
            ) : null}

            {後續補強問題.length > 0 ? (
                <div className="space-y-4">
                    <div className="text-base font-semibold text-amber-700">後續補強</div>
                    <div className="grid gap-4 xl:grid-cols-2">
                        {後續補強問題.map((card) => (
                            <Card key={card.key} className="border-amber-200">
                                <CardHeader className="pb-2">
                                    <CardTitle className="text-base text-amber-700">{card.title}</CardTitle>
                                </CardHeader>
                                <CardContent className="space-y-4">
                                    <div>
                                        <div className="text-sm font-medium mb-2">目前問題</div>
                                        <p className="text-sm text-muted-foreground leading-6">{card.problem}</p>
                                    </div>
                                    <div>
                                        <div className="text-sm font-medium mb-2">建議怎麼修</div>
                                        <ul className="list-disc pl-5 text-sm space-y-2">
                                            {card.howToFix.map((item) => (
                                                <li key={item}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                </div>
            ) : null}
        </div>
    );
}
